import { Avatar as MUIAvatar } from '@mui/material';

import './Avatar.scss';

export const Avatar = ({
  className = '',
  imageUrl,
  alt = 'Avatar',
  size = 'large',
}: {
  className?: string;
  imageUrl?: string;
  alt?: string;
  size?: 'large' | 'medium' | 'small';
}) => {
  const dimension =
    size === 'large'
      ? {
        height: '112px',
        width: '112px',
      }
      : size === 'medium'
        ? {
          height: '72px',
          width: '72px',
        }
        : {
          height: '32px',
          width: '32px',
        };
  return (
    <MUIAvatar
      alt={alt}
      className={className}
      src={imageUrl}
      sx={{
        ...dimension,
      }}
    />
  );
};
